import { Component, forwardRef, Input, ComponentFactoryResolver, ElementRef, Optional, Self, ChangeDetectorRef, ComponentFactory, Injector } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable, of } from 'rxjs';
import { ExternalSelectorComponent } from '../external-selector/external-selector.component';
import { FabbricatoPickerComponent } from '../entity-pickers/fabbricato-picker/fabbricato-picker.component';
import { map, mergeAll } from 'rxjs/operators';
import { ExternalMorphSelectorComponent, ExternalMorphEntity } from '../external-selector/external-morph-selector/external-morph-selector.component';
import { ContraenteTypeSelectorComponent } from './contraente-type-selector/contraente-type-selector.component';
import { AltroSoggettoPickerComponent } from '../entity-pickers/altro-soggetto-picker/altro-soggetto-picker.component';
import { TipoAltroSoggetto } from 'src/app/models/tipo-altro-soggetto';

type TipoContraente = 'fabbricato' | 'altroSoggetto';


@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => ContraentePickerComponent) },
  ],
  selector: 'contraente-picker',
  templateUrl: '../external-selector/external-selector.component.html',
  styleUrls: ['../external-selector/external-selector.component.scss']
})
export class ContraentePickerComponent extends ExternalMorphSelectorComponent {

  @Input() type: 'contraente' | 'controparte' = null;

  getTypeOfEntityThatUserWantsToSelect(): Observable<TipoContraente> {
    return this.dialog.open(ContraenteTypeSelectorComponent).afterClosed();
  }

  @Input()
  get externalEntityObserver(): Observable<ExternalMorphEntity> {
    return this.getExternalEntityObserver();
  };

  getExternalEntityObserver() {
    return this.getTypeOfEntityThatUserWantsToSelect() //apro selettore del tipo di contraente
      .pipe(
        map(tipoContraente => { //mappo la selezione del tipo di contraente che l'utente ha fatto ad un vero contraente
          if (!tipoContraente) return of(null); //Se l'utente esce senza selezionare tipo di contraente, restituisco observable di null in modo da non causare TypeError
          return this.getInstanceOfCorrectEntityPicker(tipoContraente) //istanzia il selettore adeguato al tipo richiesto dall'utente
            .externalEntityObserver.pipe( //dobbiamo aggiungere alla risposta classica dell'external entity picker il tipo di contraente
              map(externalEntity => { //aggiungiamo l'attributo tipo contraente attraverso l'operatore map
                if (externalEntity?.id) //Se l'utente ha selezionato davvero qualcosa... aggiungo tipoContraente
                  return new ExternalMorphEntity(externalEntity.id, externalEntity.humanIdentifier, tipoContraente)
                return null; //Altrimenti, se l'utente annulla la selezione dopo aver selezionato il tipo di contraente, ritorno null
              })
            )
        }),
        mergeAll()
      );

  }

  getInstanceOfCorrectEntityPicker(tipoContraente: TipoContraente) {
    let factory: ComponentFactory<ExternalSelectorComponent>;
    if (tipoContraente == "altroSoggetto")
      factory = this.resolver.resolveComponentFactory(AltroSoggettoPickerComponent);
    if (tipoContraente == "fabbricato")
      factory = this.resolver.resolveComponentFactory(FabbricatoPickerComponent);

    let extSelectorComponent = factory.create(this.injector).instance;

    if (tipoContraente == 'altroSoggetto') {
      extSelectorComponent.defaultSearch = this.getDefaultSearch();
    }

    return extSelectorComponent;
  }

  getDefaultSearch() {
    if (this.type == 'contraente') {
      return {
        tipo: new TipoAltroSoggetto().deserialize({
          nome: 'Contraente',
          id: 1,
        })
      }
    }
    if (this.type == 'controparte') {
      return {
        tipo: new TipoAltroSoggetto().deserialize({
          nome: 'Controparte',
          id: 2,
        })
      }
    }
    return null;
  }

}
